/**
 * Identidade institucional da AGÊNCIA VPC.
 * Editável aqui — é o que aparece na aba "Sobre" e é injetado nos prompts da Claude
 * para que toda comunicação respeite o tom da casa.
 */

export interface AgencyValue {
  id: string;
  title: string;
  description: string;
}

export const AGENCY = {
  name: "Agência VPC",
  fullName: "AGÊNCIA VPC",
  parent: "R3 Group LLC",
  city: "Orlando, FL · SP",
  founded: 2025,
  tagline: "Arquitetura do Comando",

  mission:
    "Construir narrativa, identidade e operação de venda para as empresas " +
    "do ecossistema R3 Group — com excelência criativa de agência premium, " +
    "decisão guiada por dado e velocidade calibrada por estratégia.",

  vision:
    "Ser a holding de marketing mais respeitada da costa atlântica até 2030 — " +
    "referência em ofertas irresistíveis, identidade memorável e tração mensurável " +
    "no segmento premium de turismo, fintech, infoproduto e SaaS.",

  values: [
    {
      id: "v1",
      title: "Excelência sem desculpa",
      description: "Entrega no padrão de agência premium internacional, ou não sai. Mediano não passa pela porta."
    },
    {
      id: "v2",
      title: "Cliente acima de cargo",
      description: "Quem decide o que é bom é a transformação do cliente, não a hierarquia interna."
    },
    {
      id: "v3",
      title: "Dado fala mais alto que opinião",
      description: "ROAS, LTV, CAC. Achismo perde para hipótese testada — Hopkins e Sobral entram aqui."
    },
    {
      id: "v4",
      title: "Criatividade com tração",
      description: "Bonito + que vende. Ogilvy: se não vende, não é criativo."
    },
    {
      id: "v5",
      title: "Velocidade calibrada",
      description: "Rápido como Musk, sem pular fundamentos como Bezos."
    },
    {
      id: "v6",
      title: "Cultura como ativo",
      description: "Quem ri junto, vende junto. Endomarketing não é luxo — é infraestrutura."
    },
    {
      id: "v7",
      title: "A última canetada é da liderança",
      description: "Discutimos em mesa redonda, Marcio sussurra, Trump bate o martelo. Decisão única, claríssima."
    }
  ] as AgencyValue[],

  manifesto:
    "Não somos um departamento de marketing — somos uma arquitetura. " +
    "Cada departamento, cada agente, cada sala existe para construir uma decisão clara, " +
    "uma narrativa firme e uma venda inevitável. Trabalhamos com peso de holding, " +
    "ritmo de startup e gosto de estúdio europeu. Tudo o que sai da VPC carrega R3 atrás."
};

export type AgencyIdentity = typeof AGENCY;
